/**
 * Auto-generated by scripts/generate-drizzle-schema.mjs
 * Regenerate with: make generate-schema
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    list_id: text("list_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
  },
  (table) => [
    /** ORDER BY server_ts DESC en el feed de actividad */
    index("activity_recent_by_feed").on(table.server_ts),
    /** WHERE entity_type = ? AND entity_id = ? en el historial por entidad */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
  ],
);

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY created_at en useAttachments */
    index("attachment_by_todo").on(table.todo_id, table.created_at),
    /** WHERE user_id = ? en getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// ⚡ Tabla con índice en user_id para acelerar getHasLocalDataQuery.
export const list = sqliteTable(
  "list",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    color: text("color"),
    icon: text("icon"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    theme_id: text("theme_id"),
    is_blur: integer("is_blur"),
    is_shared: integer("is_shared"),
    group_id: text("group_id"),
    follow_device_theme: integer("follow_device_theme"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE user_id = ? en useLists y getHasLocalDataQuery */
    index("list_by_user").on(table.user_id),
  ],
);

// ⚡ Tabla con índice en user_id para acelerar getHasLocalDataQuery.
export const list_group = sqliteTable(
  "list_group",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    color: text("color"),
    icon: text("icon"),
  },
  (table) => [
    /** WHERE user_id = ? en useListGroups y getHasLocalDataQuery */
    index("list_group_by_user").on(table.user_id),
  ],
);

export const list_group_item = sqliteTable(
  "list_group_item",
  {
    id: text("id").primaryKey(),
    list_id: text("list_id"),
    group_id: text("group_id"),
    added_at: text("added_at"),
    user_id: text("user_id"),
  },
  (table) => [
    /** LEFT JOIN list_group_item ON list.id = list_group_item.list_id en useLists() */
    index("list_group_item_by_list").on(table.list_id),
    /** WHERE group_id = ? ORDER BY added_at DESC en useGroupItems() */
    index("list_group_item_by_group").on(table.group_id, table.added_at),
  ],
);

// Dataset manejado por sync streams — índices no necesarios por ahora.
export const list_organization = sqliteTable("list_organization", {
  id: text("id").primaryKey(),
  list_id: text("list_id"),
  organization_id: text("organization_id"),
  added_at: text("added_at"),
  added_by: text("added_by"),
});

// Dataset pequeño por usuario — índices no necesarios por ahora.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Dataset pequeño — índices no necesarios por ahora.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Sesiones activas del usuario — dataset pequeño, sin índices.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  expires_at: text("expires_at"),
  token: text("token"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  ip_address: text("ip_address"),
  user_agent: text("user_agent"),
  user_id: text("user_id"),
  active_organization_id: text("active_organization_id"),
  device_id: text("device_id"),
});

export const subtask = sqliteTable(
  "subtask",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    text: text("text"),
    completed: integer("completed"),
    order: integer("order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY order, created_at en useSubtasks() */
    index("subtask_by_todo").on(table.todo_id, table.order, table.created_at),
    /** WHERE user_id = ? en getHasLocalDataQuery */
    index("subtask_by_user").on(table.user_id),
  ],
);

// Dataset global pequeño (~20 temas) — índices no necesarios.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// ⚡ Tabla más grande (~4500+ filas). Los índices aquí tienen el mayor impacto.
export const todo = sqliteTable(
  "todo",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    text: text("text"),
    completed: integer("completed"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    important: integer("important"),
    note: text("note"),
    due_date: text("due_date"),
    recurrence_rule: text("recurrence_rule"),
    my_day_date: text("my_day_date"),
    reminder_at: text("reminder_at"),
    is_shared: integer("is_shared"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** JOIN todo ON list.id = todo.list_id en useLists() */
    index("todo_by_list").on(table.list_id, table.completed, table.updated_at),
    /** WHERE user_id = ? en queries globales de agregación */
    index("todo_by_user").on(table.user_id, table.completed, table.important),
    /** WHERE user_id = ? AND my_day_date IS NOT NULL AND my_day_date <= ? ORDER BY updated_at DESC en useMyDay() */
    index("todo_by_my_day").on(table.user_id, table.my_day_date, table.updated_at),
    /** WHERE due_date IS NOT NULL ORDER BY completed ASC, updated_at DESC en useTodos({ plannedOnly }) */
    index("todo_by_due_date").on(table.due_date, table.completed, table.updated_at),
    /** WHERE important = 1 ORDER BY completed ASC, updated_at DESC en useTodos({ importantOnly }) */
    index("todo_by_important").on(table.important, table.completed, table.updated_at),
    /** ORDER BY completed ASC, updated_at DESC en useTodos({ filter: 'all' }) */
    index("todo_by_global_sort").on(table.completed, table.updated_at),
    /** WHERE completed = 0 AND due_date > datetime('now') ORDER BY due_date ASC */
    index("todo_by_reminders").on(table.completed, table.due_date),
  ],
);

// Solo 1 fila por usuario — índices no necesarios.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  banned: integer("banned"),
  ban_reason: text("ban_reason"),
  ban_expires: text("ban_expires"),
  two_factor_enabled: integer("two_factor_enabled"),
  two_factor_secret: text("two_factor_secret"),
  two_factor_backup_codes: text("two_factor_backup_codes"),
  deletion_requested_at: text("deletion_requested_at"),
});

// 🎯 FAMIDEX — CATÁLOGO GLOBAL [H] (compartido, read-mostly, no propiedad de
// ninguna org). Llega por el stream público `catalog_public` (sin UNION con la
// colección). El cliente lo cachea para ojear offline.
export const catalog_series = sqliteTable("catalog_series", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  // total de ítems de la serie: base del progreso por serie (poseídos / total).
  total_items: integer("total_items"),
  release_year: integer("release_year"),
  image_url: text("image_url"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const catalog_product = sqliteTable(
  "catalog_product",
  {
    id: text("id").primaryKey(),
    ean: text("ean"),
    upc: text("upc"),
    edition_name: text("edition_name"),
    release_year: integer("release_year"),
    category: text("category"),
    series_id: text("series_id"),
    image_url: text("image_url"),
    description: text("description"),
    is_limited: integer("is_limited"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE series_id = ? para el progreso por serie */
    index("catalog_product_by_series").on(table.series_id),
    /** WHERE category = ? en el filtro del catálogo */
    index("catalog_product_by_category").on(table.category),
    /** WHERE ean = ? en la resolución del escáner */
    index("catalog_product_by_ean").on(table.ean),
  ],
);

export const catalog_part = sqliteTable(
  "catalog_part",
  {
    id: text("id").primaryKey(),
    product_id: text("product_id"),
    name: text("name"),
    kind: text("kind"),
    image_url: text("image_url"),
    sort_order: integer("sort_order"),
  },
  (table) => [
    /** WHERE product_id = ? ORDER BY sort_order en el detalle */
    index("catalog_part_by_product").on(table.product_id, table.sort_order),
  ],
);

// 🎯 FAMIDEX — COLECCIÓN PRIVADA DEL USUARIO [L] (local-first, guest→cuenta).
// Aislada por user_id (stream `my_collection`). El write-path aplica
// UPDATE-or-INSERT (las vistas PowerSync no admiten UPSERT, gotcha #15): el
// cliente resuelve la unicidad por (user_id, product_id) — ver mutations.
export const user_collection = sqliteTable(
  "user_collection",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    product_id: text("product_id"),
    // owned | wishlist | duplicate
    state: text("state"),
    quantity: integer("quantity"),
    condition: text("condition"),
    notes: text("notes"),
    acquired_at: text("acquired_at"),
    deleted_at: text("deleted_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE user_id = ? en el stream privado, progreso y getHasLocalDataQuery */
    index("user_collection_by_user").on(table.user_id),
    /** WHERE user_id = ? AND product_id = ? en el UPDATE-or-INSERT del cliente */
    index("user_collection_by_user_product").on(table.user_id, table.product_id),
  ],
);

// 👥 FAMIDEX — GRAFO SOCIAL + CHAT/DM + NOTIFICACIONES (Wave 1, agente D). Todo
// [L] local-first, AISLADO por usuario (streams social_follows / chat_threads /
// chat_messages / social_notifications). Perfil desnormalizado (stamp
// server-side) para que el módulo sea self-contained (sin cross-sync del user).
export const follow = sqliteTable(
  "follow",
  {
    id: text("id").primaryKey(),
    follower_id: text("follower_id"),
    followee_id: text("followee_id"),
    follower_name: text("follower_name"),
    follower_image: text("follower_image"),
    followee_name: text("followee_name"),
    followee_image: text("followee_image"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE follower_id = ? -> "seguidos" y getHasLocalDataQuery */
    index("follow_by_follower").on(table.follower_id),
    /** WHERE followee_id = ? -> "seguidores" */
    index("follow_by_followee").on(table.followee_id),
  ],
);

export const chat_thread = sqliteTable(
  "chat_thread",
  {
    id: text("id").primaryKey(),
    user_a: text("user_a"),
    user_b: text("user_b"),
    a_name: text("a_name"),
    a_image: text("a_image"),
    b_name: text("b_name"),
    b_image: text("b_image"),
    last_message_at: text("last_message_at"),
    last_message_preview: text("last_message_preview"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    index("chat_thread_by_a").on(table.user_a),
    index("chat_thread_by_b").on(table.user_b),
  ],
);

export const chat_message = sqliteTable(
  "chat_message",
  {
    id: text("id").primaryKey(),
    thread_id: text("thread_id"),
    sender_id: text("sender_id"),
    recipient_id: text("recipient_id"),
    body: text("body"),
    read_at: text("read_at"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE thread_id = ? ORDER BY created_at en la conversacion */
    index("chat_message_by_thread").on(table.thread_id, table.created_at),
    index("chat_message_by_sender").on(table.sender_id),
    index("chat_message_by_recipient").on(table.recipient_id),
  ],
);

export const social_notification = sqliteTable(
  "social_notification",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    kind: text("kind"),
    actor_id: text("actor_id"),
    actor_name: text("actor_name"),
    actor_image: text("actor_image"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    body: text("body"),
    read_at: text("read_at"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE user_id = ? ORDER BY created_at DESC en el centro de notificaciones */
    index("social_notification_by_user").on(table.user_id, table.created_at),
  ],
);

// FAMIDEX Wave 1-F — ECONOMÍA de Bellotas [S] (server-authoritative). El cliente
// LEE estas tablas como proyección read-only (stream privado `my_wallet` +
// público `shop_catalog`); NUNCA las escribe (el saldo lo muta sólo el servidor
// por REST /api/economy/*). Sin UNION con otros streams (gotcha #16).
export const wallet = sqliteTable("wallet", {
  user_id: text("user_id").primaryKey(),
  // saldo en bellotas (entero, nunca negativo).
  balance_acorns: integer("balance_acorns"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const acorn_transaction = sqliteTable(
  "acorn_transaction",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    delta: integer("delta"),
    // purchase | reward_video | daily_login | redemption | admin
    reason: text("reason"),
    balance_after: integer("balance_after"),
    ref_id: text("ref_id"),
    created_at: text("created_at"),
  },
  (table) => [
    /** Ledger del usuario, más reciente primero */
    index("acorn_transaction_by_user").on(table.user_id, table.created_at),
  ],
);

export const shop_product = sqliteTable(
  "shop_product",
  {
    id: text("id").primaryKey(),
    // pack | frame | sticker
    kind: text("kind"),
    name: text("name"),
    description: text("description"),
    image_url: text("image_url"),
    icon: text("icon"),
    price_acorns: integer("price_acorns"),
    acorns_granted: integer("acorns_granted"),
    price_cents: integer("price_cents"),
    badge: text("badge"),
    is_seasonal: integer("is_seasonal"),
    is_active: integer("is_active"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** Tienda agrupada por familia */
    index("shop_product_by_kind").on(table.kind, table.sort_order),
  ],
);

export const redemption = sqliteTable(
  "redemption",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    shop_product_id: text("shop_product_id"),
    cost_acorns: integer("cost_acorns"),
    created_at: text("created_at"),
  },
  (table) => [index("redemption_by_user").on(table.user_id, table.created_at)],
);

export const daily_reward_claim = sqliteTable(
  "daily_reward_claim",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    claimed_on: text("claimed_on"),
    amount: integer("amount"),
    streak_day: integer("streak_day"),
    created_at: text("created_at"),
  },
  (table) => [index("daily_reward_claim_by_user").on(table.user_id, table.claimed_on)],
);

// 🎮 FAMIDEX — GAMIFICACIÓN (Wave 1, agente E). Catálogo de stickers [H]
// (público, sin dueño) por el stream `sticker_catalog`; ledger de XP y stickers
// poseídos [L] (privados, aislados por user_id) por `my_gamification`.
export const sticker_pack = sqliteTable("sticker_pack", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  description: text("description"),
  season: text("season"),
  // total de stickers del paquete: base del progreso por paquete (poseídos / total).
  total_items: integer("total_items"),
  image_url: text("image_url"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const sticker = sqliteTable(
  "sticker",
  {
    id: text("id").primaryKey(),
    pack_id: text("pack_id"),
    name: text("name"),
    image_url: text("image_url"),
    // common | rare | exclusive
    rarity: text("rarity"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE pack_id = ? ORDER BY sort_order en el álbum de un paquete */
    index("sticker_by_pack").on(table.pack_id, table.sort_order),
  ],
);

// LEDGER de XP append-only [L]. SERVER-AUTHORITATIVE: el servidor estampa `xp`
// desde su matriz por `action` (el cliente no puede forjar la cantidad). El
// rango se DERIVA de la suma por gamification-core (reducer puro), no se guarda.
export const xp_event = sqliteTable(
  "xp_event",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    // add_item | friend | post | like_received | like_given | daily_login
    action: text("action"),
    xp: integer("xp"),
    source_id: text("source_id"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE user_id = ? ORDER BY created_at en el stream privado + suma del ledger */
    index("xp_event_by_user").on(table.user_id, table.created_at),
  ],
);

// Stickers que POSEE el usuario [L] (aislado por user_id). UPDATE-or-INSERT por
// (user_id, sticker_id) en el write-path (las vistas PowerSync no admiten UPSERT).
export const user_sticker = sqliteTable(
  "user_sticker",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    sticker_id: text("sticker_id"),
    is_favorite: integer("is_favorite"),
    acquired_at: text("acquired_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE user_id = ? en el stream privado, el álbum y getHasLocalDataQuery */
    index("user_sticker_by_user").on(table.user_id),
    /** WHERE user_id = ? AND sticker_id = ? en el UPDATE-or-INSERT del cliente */
    index("user_sticker_by_user_sticker").on(table.user_id, table.sticker_id),
  ],
);

// ─── PERFIL DEL COLECCIONISTA (Wave 1 · W1-PROFILE) [L] ─────────────────────
// Modelo PROPIO del módulo perfil (/journal): destacados, favoritos, etiquetas
// y privacidad. Todo PRIVADO y aislado por user_id (stream `my_profile`).
export const collector_profile = sqliteTable(
  "collector_profile",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    display_name: text("display_name"),
    bio: text("bio"),
    frame_id: text("frame_id"),
    is_private: integer("is_private"),
    collection_visibility: text("collection_visibility"),
    wishlist_visibility: text("wishlist_visibility"),
    show_location: integer("show_location"),
    comment_permission: text("comment_permission"),
    tag_permission: text("tag_permission"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE user_id = ? en el stream `my_profile` y el sweep guest→cuenta */
    index("collector_profile_by_user").on(table.user_id),
  ],
);

export const profile_featured = sqliteTable(
  "profile_featured",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    product_id: text("product_id"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE user_id = ? ORDER BY sort_order en la fila de destacados */
    index("profile_featured_by_user").on(table.user_id, table.sort_order),
  ],
);

export const profile_favorite = sqliteTable(
  "profile_favorite",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    product_id: text("product_id"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE user_id = ? en la pestaña favoritos */
    index("profile_favorite_by_user").on(table.user_id),
  ],
);

export const profile_tag = sqliteTable(
  "profile_tag",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    product_id: text("product_id"),
    label: text("label"),
    created_at: text("created_at"),
  },
  (table) => [
    /** WHERE user_id = ? en la pestaña etiquetas */
    index("profile_tag_by_user").on(table.user_id, table.label),
  ],
);

// 📣 FAMIDEX — COMUNIDAD [L/H] (Wave 1 · agente C). Feed público de
// publicaciones + likes/comentarios (papelera en post/post_comment) + reportes
// privados. El write-path estampa el user_id del autor (aislamiento).
export const post = sqliteTable(
  "post",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    author_name: text("author_name"),
    author_image: text("author_image"),
    caption: text("caption"),
    product_id: text("product_id"),
    // array JSON de URLs de imágenes (0..5)
    media: text("media"),
    rating: integer("rating"),
    visibility: text("visibility"),
    deleted_at: text("deleted_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    index("post_by_created_at").on(table.created_at),
    index("post_by_user").on(table.user_id),
    index("post_by_product").on(table.product_id),
  ],
);

export const post_like = sqliteTable(
  "post_like",
  {
    id: text("id").primaryKey(),
    post_id: text("post_id"),
    user_id: text("user_id"),
    created_at: text("created_at"),
  },
  (table) => [
    index("post_like_by_post").on(table.post_id),
    index("post_like_by_post_user").on(table.post_id, table.user_id),
  ],
);

export const post_comment = sqliteTable(
  "post_comment",
  {
    id: text("id").primaryKey(),
    post_id: text("post_id"),
    user_id: text("user_id"),
    author_name: text("author_name"),
    author_image: text("author_image"),
    body: text("body"),
    deleted_at: text("deleted_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [index("post_comment_by_post").on(table.post_id, table.created_at)],
);

export const post_report = sqliteTable(
  "post_report",
  {
    id: text("id").primaryKey(),
    post_id: text("post_id"),
    user_id: text("user_id"),
    reason: text("reason"),
    details: text("details"),
    status: text("status"),
    created_at: text("created_at"),
  },
  (table) => [
    index("post_report_by_post").on(table.post_id),
    index("post_report_by_post_user").on(table.post_id, table.user_id),
  ],
);

export const drizzleSchema = {
  activity_recent,
  catalog_series,
  catalog_product,
  catalog_part,
  user_collection,
  post,
  post_like,
  post_comment,
  post_report,
  collector_profile,
  profile_featured,
  profile_favorite,
  profile_tag,
  sticker_pack,
  sticker,
  xp_event,
  user_sticker,
  wallet,
  acorn_transaction,
  shop_product,
  redemption,
  daily_reward_claim,
  attachment,
  font_family,
  font_variant,
  list,
  list_group,
  list_group_item,
  list_organization,
  member,
  organization,
  session,
  subtask,
  themes,
  todo,
  user,
  follow,
  chat_thread,
  chat_message,
  social_notification,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "attachment",
  "list",
  "list_group",
  "list_group_item",
  "subtask",
  "todo",
  // 🎯 colección privada del usuario — barrida al visitante→cuenta y en el
  // getHasLocalDataQuery (dato local-first propiedad del usuario).
  "user_collection",
  // 🧑‍🎨 perfil del coleccionista [L] (Wave 1 · W1-PROFILE): destacados,
  // favoritos, etiquetas y ajustes de privacidad/marco — dato del usuario.
  "collector_profile",
  "profile_featured",
  "profile_favorite",
  "profile_tag",
  // 🎮 gamificación [L]: ledger de XP y stickers poseídos (dato del usuario).
  "xp_event",
  "user_sticker",
  // 👥 grafo social [L]: aristas de follow, hilos/mensajes de chat y
  // notificaciones — dato del usuario (barrido visitante->cuenta + hasLocalData).
  "follow",
  "chat_thread",
  "chat_message",
  "social_notification",
  // 📣 comunidad [L]: publicaciones propias, likes, comentarios y reportes del
  // usuario — dato del usuario (barrido visitante→cuenta + hasLocalData).
  "post",
  "post_like",
  "post_comment",
  "post_report",
] as const;

export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type List = InferSelectModel<typeof list>;
export type ListInsert = InferInsertModel<typeof list>;
export type ListRecord = List;
export type ListGroup = InferSelectModel<typeof list_group>;
export type ListGroupInsert = InferInsertModel<typeof list_group>;
export type ListGroupRecord = ListGroup;
export type ListGroupItem = InferSelectModel<typeof list_group_item>;
export type ListGroupItemInsert = InferInsertModel<typeof list_group_item>;
export type ListGroupItemRecord = ListGroupItem;
export type ListOrganization = InferSelectModel<typeof list_organization>;
export type ListOrganizationInsert = InferInsertModel<typeof list_organization>;
export type ListOrganizationRecord = ListOrganization;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Subtask = InferSelectModel<typeof subtask>;
export type SubtaskInsert = InferInsertModel<typeof subtask>;
export type SubtaskRecord = Subtask;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type Todo = InferSelectModel<typeof todo>;
export type TodoInsert = InferInsertModel<typeof todo>;
export type TodoRecord = Todo;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type CatalogSeries = InferSelectModel<typeof catalog_series>;
export type CatalogSeriesInsert = InferInsertModel<typeof catalog_series>;
export type CatalogSeriesRecord = CatalogSeries;
export type CatalogProduct = InferSelectModel<typeof catalog_product>;
export type CatalogProductInsert = InferInsertModel<typeof catalog_product>;
export type CatalogProductRecord = CatalogProduct;
export type CatalogPart = InferSelectModel<typeof catalog_part>;
export type CatalogPartInsert = InferInsertModel<typeof catalog_part>;
export type CatalogPartRecord = CatalogPart;
export type UserCollection = InferSelectModel<typeof user_collection>;
export type UserCollectionInsert = InferInsertModel<typeof user_collection>;
export type UserCollectionRecord = UserCollection;
export type CollectorProfile = InferSelectModel<typeof collector_profile>;
export type CollectorProfileInsert = InferInsertModel<typeof collector_profile>;
export type CollectorProfileRecord = CollectorProfile;
export type ProfileFeatured = InferSelectModel<typeof profile_featured>;
export type ProfileFeaturedInsert = InferInsertModel<typeof profile_featured>;
export type ProfileFeaturedRecord = ProfileFeatured;
export type ProfileFavorite = InferSelectModel<typeof profile_favorite>;
export type ProfileFavoriteInsert = InferInsertModel<typeof profile_favorite>;
export type ProfileFavoriteRecord = ProfileFavorite;
export type ProfileTag = InferSelectModel<typeof profile_tag>;
export type ProfileTagInsert = InferInsertModel<typeof profile_tag>;
export type ProfileTagRecord = ProfileTag;
export type Follow = InferSelectModel<typeof follow>;
export type FollowInsert = InferInsertModel<typeof follow>;
export type FollowRecord = Follow;
export type ChatThread = InferSelectModel<typeof chat_thread>;
export type ChatThreadInsert = InferInsertModel<typeof chat_thread>;
export type ChatThreadRecord = ChatThread;
export type ChatMessage = InferSelectModel<typeof chat_message>;
export type ChatMessageInsert = InferInsertModel<typeof chat_message>;
export type ChatMessageRecord = ChatMessage;
export type SocialNotification = InferSelectModel<typeof social_notification>;
export type SocialNotificationInsert = InferInsertModel<typeof social_notification>;
export type SocialNotificationRecord = SocialNotification;
export type Wallet = InferSelectModel<typeof wallet>;
export type WalletInsert = InferInsertModel<typeof wallet>;
export type WalletRecord = Wallet;
export type AcornTransaction = InferSelectModel<typeof acorn_transaction>;
export type AcornTransactionInsert = InferInsertModel<typeof acorn_transaction>;
export type AcornTransactionRecord = AcornTransaction;
export type ShopProduct = InferSelectModel<typeof shop_product>;
export type ShopProductInsert = InferInsertModel<typeof shop_product>;
export type ShopProductRecord = ShopProduct;
export type Redemption = InferSelectModel<typeof redemption>;
export type RedemptionInsert = InferInsertModel<typeof redemption>;
export type RedemptionRecord = Redemption;
export type DailyRewardClaim = InferSelectModel<typeof daily_reward_claim>;
export type DailyRewardClaimInsert = InferInsertModel<typeof daily_reward_claim>;
export type DailyRewardClaimRecord = DailyRewardClaim;
export type StickerPack = InferSelectModel<typeof sticker_pack>;
export type StickerPackInsert = InferInsertModel<typeof sticker_pack>;
export type StickerPackRecord = StickerPack;
export type Sticker = InferSelectModel<typeof sticker>;
export type StickerInsert = InferInsertModel<typeof sticker>;
export type StickerRecord = Sticker;
export type XpEvent = InferSelectModel<typeof xp_event>;
export type XpEventInsert = InferInsertModel<typeof xp_event>;
export type XpEventRecord = XpEvent;
export type UserSticker = InferSelectModel<typeof user_sticker>;
export type UserStickerInsert = InferInsertModel<typeof user_sticker>;
export type UserStickerRecord = UserSticker;

export type Post = InferSelectModel<typeof post>;
export type PostInsert = InferInsertModel<typeof post>;
export type PostRecord = Post;
export type PostLike = InferSelectModel<typeof post_like>;
export type PostLikeInsert = InferInsertModel<typeof post_like>;
export type PostLikeRecord = PostLike;
export type PostComment = InferSelectModel<typeof post_comment>;
export type PostCommentInsert = InferInsertModel<typeof post_comment>;
export type PostCommentRecord = PostComment;
export type PostReport = InferSelectModel<typeof post_report>;
export type PostReportInsert = InferInsertModel<typeof post_report>;
export type PostReportRecord = PostReport;
